var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SchemaTablePage", {
    ref: "tablePageRef",
    attrs: {
      "layout-mode": "tab",
      "show-summary": "",
      "search-schema": _vm.searchSchema,
      columns: _vm.tableColumns,
      "default-query": _vm.defaultQuery,
      request: _vm.request,
      "build-params": _vm.buildParams,
      "parse-result": _vm.parseResult,
      "table-attrs": _vm.tableAttrs,
    },
    scopedSlots: _vm._u([
      {
        key: "search-amountRange",
        fn: function ({ query }) {
          return [
            _c(
              "div",
              { staticClass: "amount-range", staticStyle: { width: "100%" } },
              [
                _c("el-input-number", {
                  attrs: { controls: false, placeholder: "最小金额", min: 0 },
                  model: {
                    value: query.minOrderAmount,
                    callback: function ($$v) {
                      _vm.$set(query, "minOrderAmount", $$v)
                    },
                    expression: "query.minOrderAmount",
                  },
                }),
                _c("div", { staticStyle: { width: "10px" } }),
                _c("el-input-number", {
                  attrs: { controls: false, placeholder: "最大金额", min: 0 },
                  model: {
                    value: query.maxOrderAmount,
                    callback: function ($$v) {
                      _vm.$set(query, "maxOrderAmount", $$v)
                    },
                    expression: "query.maxOrderAmount",
                  },
                }),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "colOrderNo",
        fn: function ({ row }) {
          return [
            _c(
              "el-button",
              {
                attrs: { type: "text", size: "mini" },
                on: {
                  click: function ($event) {
                    return _vm.openDetail(row.orderNo)
                  },
                },
              },
              [_vm._v(_vm._s(row.orderNo))]
            ),
          ]
        },
      },
      {
        key: "colMemberAccount",
        fn: function ({ row }) {
          return [
            _c("MemberAccountCell", {
              attrs: {
                row: row,
                username: row.memberAccount,
                uid: row.uid,
                "vip-level": row.memberLevel,
              },
            }),
          ]
        },
      },
      {
        key: "colOrderAmount",
        fn: function ({ row }) {
          return [_vm._v(_vm._s(_vm._f("centsToYuan")(row.orderAmount)))]
        },
      },
      {
        key: "colArrivalAmount",
        fn: function ({ row }) {
          return [_vm._v(_vm._s(_vm._f("centsToYuan")(row.arrivalAmount)))]
        },
      },
      {
        key: "colTopUpAmount",
        fn: function ({ row }) {
          return [_vm._v(_vm._s(_vm._f("centsToYuan")(row.topUpAmount)))]
        },
      },
      {
        key: "colDepositDiscount",
        fn: function ({ row }) {
          return [_vm._v(_vm._s(_vm._f("centsToYuan")(row.depositDiscount)))]
        },
      },
      {
        key: "colPayinMethod",
        fn: function ({ row }) {
          return [_vm._v(_vm._s(_vm.payinMethodLabel(row.payin_method)))]
        },
      },
      {
        key: "colStatus",
        fn: function ({ row }) {
          return [
            _c(
              "el-tag",
              {
                attrs: { size: "mini", type: _vm.getStatusTagType(row.status) },
              },
              [_vm._v(_vm._s(row.status))]
            ),
          ]
        },
      },
      {
        key: "table-header",
        fn: function () {
          return [
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  size: "mini",
                  loading: _vm.exporting,
                },
                on: { click: _vm.handleExport },
              },
              [_vm._v("导出 Excel")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }